import WhyFlyPrivate from './WhyFlyPrivate';

export default WhyFlyPrivate;
